import { Patient, PatientQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet, UseCqrsQueryResult } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

export const usePatientQuery = (patientId: number): UseCqrsQueryResult<Patient> => {
   return useCqrsGet<Patient>(() => {
      const query = new PatientQuery();
      query.id = Slot.of(patientId);
      return query;
   });
};
